import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { ListItems } from '../containers/Community';

export default class ViewCommunityItemBtn extends Component {

	state = {
		open: false,
		isNewCommentShow: false
	};

	render() {
        const { item, 
				icon, 
				dataStyle, 
				headerText, 
				iconText, 
				itemType, 
				isMobile, 
				itemCount, 
				onSaveComment, 
				onDeleteComment,
				deleteItem
			} = this.props;
        const { open } = this.state;
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{width: dataStyle.width, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									{ itemType !== 'comment' &&    
										<FontAwesomeIcon  icon={icon} title={iconText}
										style={{ marginRight: 5, color: COLORS.orange }} />
									}
									<span>{headerText}</span>
							    </div>
							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
						 	<ListItems
							   postId={item._id} 
							   isMobile={isMobile} 
							   itemType = {itemType} 
							   onClose={() => this.setState({ open: false })}  
							   onDeleteComment={onDeleteComment} 
							   onSaveComment={onSaveComment}
							   deleteItem = { deleteItem }
							/>   
						</div>
	        </div>
	      </Modal>
			{ itemType === 'comment' ? 
				<span onClick={() => this.setState({open:true})}> See Previous Comments </span>
				:
				<span
					className="link"
					onClick={() => this.setState({open:true})}
					style={{float:'right'}}>
					{itemCount}
				</span>
			}
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/ViewCommunityItemButton.js